import VuexPersistence from 'vuex-persist';
import {
  STORAGE_VUEX_AUDIO_PLAYER_KEY,
} from '@motionelements/core/src/app.constants.js';

export default new VuexPersistence({
  key: STORAGE_VUEX_AUDIO_PLAYER_KEY,
  storage: window.sessionStorage,
  reducer: ({ audioPlayer }) => ({
    audioPlayer: {
      sounds: audioPlayer.sounds,
    },
    // hash: `${user.jwt.id}|${user.language}|${user.currencyCode}|${STORAGE_VUEX_AUDIO_PLAYER_VERSION}`,
  }),
  // eslint-disable-next-line
  filter: (mutation) => {
    return [
      'audioPlayer/setSoundProgress',
    ].includes(mutation.type);
  },
});
